// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2WUo_","active":"Item_active__1qJSM","head":"Item_head__1Q_wX","body":"Item_body__1AWCl","button":"Item_button__3yRVL"};